<script setup>
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import CompanySortMenu from './components/CompanySortMenu.vue';

defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  activeSort: { type: String, default: 'name' },
  activeOrdering: { type: String, default: '' },
});

const emit = defineEmits(['search', 'update:sort']);
</script>

<template>
  <header class="sticky top-0 z-10 px-6">
    <div
      class="mx-auto flex w-full max-w-5xl items-start justify-between gap-2 py-6 sm:items-center"
    >
      <span class="truncate text-heading-1 text-n-slate-12">
        {{ headerTitle }}
      </span>
      <div class="flex flex-shrink-0 flex-row items-center gap-2">
        <div class="flex items-center">
          <CompanySortMenu
            :active-sort="activeSort"
            :active-ordering="activeOrdering"
            @update:sort="emit('update:sort', $event)"
          />
        </div>
        <div v-if="showSearch" class="flex w-full items-center gap-2">
          <Input
            :model-value="searchValue"
            type="search"
            :placeholder="$t('COMPANIES.SEARCH_PLACEHOLDER')"
            :custom-input-class="[
              'h-8 [&:not(.focus)]:!border-transparent bg-n-alpha-2 dark:bg-n-solid-1 ltr:!pl-8 !py-1 rtl:!pr-8',
            ]"
            class="w-full"
            @input="emit('search', $event.target.value)"
          >
            <template #prefix>
              <Icon
                icon="i-lucide-search"
                class="absolute top-1/2 size-4 -translate-y-1/2 text-n-slate-11 ltr:left-2 rtl:right-2"
              />
            </template>
          </Input>
        </div>
      </div>
    </div>
  </header>
</template>
